var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"viewBox":"0 0 25 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M15.5 19L9 12.5 15.5 6","stroke":"#6BBB32","stroke-width":"1.204"}})])}
var staticRenderFns = []

export { render, staticRenderFns }